import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { extractTokenFromUrl, getToken, setToken } from '@shared/utils/token-storage';
import { getUserRoles, isTokenExpired } from '@shared/utils/jwt';

export const ROLES = {
  USER: 'CustomerOnboardingUser',
  ADMIN: 'CustomerOnboardingAdmin',
  READER: 'CustomerOnboardingViewOnlyUser',
} as const;

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);

  const urlToken = extractTokenFromUrl();
  if (urlToken && !isTokenExpired(urlToken)) {
    setToken(urlToken);
  }

  const token = getToken();
  if (!token || isTokenExpired(token)) {
    router.navigate(['/unauthorized']);
    return false;
  }

  return true;
};

export const roleGuard = (allowedRoles: string[]): CanActivateFn =>
  () => {
    const router = inject(Router);
    const token = getToken();
    const userRoles = token ? getUserRoles(token) : [];
    const isViewOnly = userRoles.includes(ROLES.READER);
    if (isViewOnly && !allowedRoles.includes(ROLES.READER)) {
      router.navigate(['/unauthorized']);
      return false;
    }
    const hasAccess = userRoles.some((r) => allowedRoles.includes(r));
    if (!hasAccess) {
      router.navigate(['/unauthorized']);
      return false;
    }
    return true;
  };

export const isViewOnlyUser = (): boolean => {
  const token = getToken();
  if (!token || isTokenExpired(token)) {
    return false;
  }

  const userRoles = getUserRoles(token);
  return userRoles.includes(ROLES.READER);
};
